import { render, staticRenderFns } from "./statut_bar.vue?vue&type=template&id=089aba74"
import script from "./statut_bar.js?vue&type=script&lang=js&external"
export * from "./statut_bar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports